import React from 'react'
import PropTypes from 'prop-types'
import { Selector } from '@leverege/ui-elements'
import style from './style.css'

const { Button } = require( 'react-bootstrap' )
const Autosuggest = require( 'react-autosuggest' )
const classnames = require( 'classnames' )
const { TextInput, Flex } = require( '../../views' )

class PathEditor extends React.Component {
  static propTypes = {
    disabled : PropTypes.bool,
    path : PropTypes.oneOfType( [ PropTypes.array, PropTypes.string ] ).isRequired,
    onChange : PropTypes.func,
    index : PropTypes.number.isRequired,
    create : PropTypes.bool,
    pathSuggestions : PropTypes.array
  };

  static defaultProps = {
    disabled : false,
    create : false,
    onChange : () => {},
    pathSuggestions : []
  };

  static castTypes = [
    {
      value : undefined,
      name : 'none'
    },
    {
      value : 'boolean',
      name : 'boolean'
    },
    {
      value : 'integer',
      name : 'integer'
    },
    {
      value : 'float',
      name : 'float'
    },
    {
      value : 'string',
      name : 'string'
    },
    {
      value : 'time',
      name : 'timestamp'
    },
    {
      value : 'msTime',
      name : 'millisecond time'
    },
    {
      value : 'object',
      name : 'object'
    },
  ]

  static getPathString( path ) {
    let pathString
    if ( typeof path !== 'string' ) {
      pathString = path[0]
    } else {
      pathString = path
    }
    return pathString
  }

  constructor( props, context ) {
    super( props, context )
    const { path } = props

    this.state = {
      suggestions : [],
      partialPath : PathEditor.getPathString( path ) || ''
    }

  }

  componentDidUpdate( prevProps ) {
    const { path : oldPath } = prevProps
    const { path } = this.props

    if ( path !== oldPath ) {
      this.setState( { partialPath : PathEditor.getPathString( path ) } )
    }

  }

  onChangeSuggestionInput = ( event, { newValue } ) => {
    this.setState( {
      partialPath : newValue
    } )
  }

  onChangePath = ( newPath ) => {
    const { onChange, index } = this.props
    onChange( { index, path : 'path', value : newPath } )
  }

  onChangeAlias = ( newAlias ) => {
    const { onChange, index } = this.props
    onChange( { index, path : 'alias', value : newAlias || undefined } )
  }

  onChangeCast = ( { value } ) => {
    const { onChange, index } = this.props
    onChange( { index, path : 'cast', value } )
  }

  onCreate = () => {
    const { onChange, index } = this.props
    onChange( { index, action : 'create' } )
  }

  onDelete = () => {
    const { onChange, index } = this.props
    onChange( { index, action : 'delete' } )
  }

  onSuggestionsFetchRequested = ( { value, ...rest } ) => {
    const { pathSuggestions } = this.props
    const suggestions = pathSuggestions && pathSuggestions.filter( ( suggestion ) => {
      return suggestion && suggestion.path && suggestion.path.includes( value )
    } )
    this.setState( {
      suggestions : suggestions || []
    } )
  }

  onSuggestionsClearRequested = () => {
    this.setState( {
      suggestions : []
    } )
  }

  getSuggestionValue = ( suggestion ) => {
    return suggestion && suggestion.path
  }

  renderContainer = ( { containerProps, children, query } ) => {
    return (
      <div {...containerProps} className={classnames( containerProps.className || '', style.suggestionsContainer )}>
        {children}
      </div>
    )
  }

  onSuggestionSelected = ( event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method } ) => {
    if ( suggestion && suggestion.path ) {
      this.onChangePath( suggestion.path )
    }
  }

  onInputBlur = () => {
    const { partialPath } = this.state
    this.onChangePath( partialPath )
  }

  onInputKeyPress = ( event ) => {
    const { partialPath } = this.state
    if ( event.charCode === 13 ) {
      this.onChangePath( partialPath )
    }
  }

  renderSuggestion = ( suggestion ) => {
    const { partialPath } = this.state

    let start = '', highlight = '', end = ''
    if ( suggestion && suggestion.path ) {
      const index = suggestion.path.indexOf( partialPath )
      start = suggestion.path.slice( 0, index )
      highlight = suggestion.path.slice( index, index + partialPath.length )
      end = suggestion.path.slice( index + partialPath.length )
    }
    return (
      <div className={style.suggestion}>
        <div>
          {start}
        </div>
        <div className={style.highlighted}>
          {highlight}
        </div>
        <div>
          {end}
        </div>
      </div>
    )
  }

  render() {
    const { disabled, path, create } = this.props
    const { suggestions, partialPath } = this.state

    let pathString, alias, cast
    if ( typeof path !== 'string' ) {
      pathString = path[0]
      alias = path[1]
      cast = path[3]
    } else {
      pathString = path
    }

    const inputProps = {
      value : partialPath,
      onChange : this.onChangeSuggestionInput,
      onBlur : this.onInputBlur,
      onKeyPress : this.onInputKeyPress
    }

    return (
      <Flex className={style.pathEditor} direction="row" align="flex-end">
        <Flex variant="noSpace" direction="column" align="flex-start">
          <label>
            Path:
          </label>
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            onSuggestionSelected={this.onSuggestionSelected}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            renderSuggestionsContainer={this.renderContainer}
            inputProps={inputProps}/>
        </Flex>
        <Flex variant="noSpace" direction="column" align="flex-start">
          <label>
            Alias:
          </label>
          <TextInput
            value={alias}
            disabled={disabled}
            onChange={this.onChangeAlias} />
        </Flex>
        <Flex variant="noSpace" direction="column" align="flex-start">
          <label>
            Cast:
          </label>
          <Selector
            className={style.castDrop}
            values={PathEditor.castTypes}
            value={cast}
            onChange={this.onChangeCast} />
        </Flex>
        {
          !disabled &&
          (
            <Button
              bsStyle="link"
              className={style.button}
              onClick={create ? this.onCreate : this.onDelete}>
              <i className={create ? 'fa fa-plus' : 'fa fa-trash'} />
            </Button>
          )
        }
      </Flex>
    )
  }
}

exports.PathEditor = PathEditor
